import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as Objecs from '@core/objects';
import { AddRequest, AddProjectErrors } from '@app/models/add-project';

export interface AddProject {
    data: AddRequest;
    savedProject: Objecs.Request | null;
    creatingNewProject: boolean;
    saved: boolean;
    errors: AddProjectErrors;
}

export const initialState: AddProject = {
    data: null,
    savedProject: null,
    creatingNewProject: false,
    saved: false,
    errors: {
        due_date: false,
        info: false,
        files: false,
        labels: false,
        version: false,
        workflow: false,
        forbidden: false,
        unauthorized: false,
        server: false,
        other: false
    }
};

export const addProjectsFeatureSelector = createFeatureSelector<AddProject>('new_project');

export const addProjectSelector = createSelector(
    addProjectsFeatureSelector,
    (state: AddProject) => state.data
);

export const addProjectErrorsSelector = createSelector(
    addProjectsFeatureSelector,
    (state: AddProject) => state.errors
);


export const savedProjectSelector = createSelector(
    addProjectsFeatureSelector,
    (state: AddProject) => state.savedProject
);

export const creatingNewProjectSelector = createSelector(
    addProjectsFeatureSelector,
    (state: AddProject) => state.creatingNewProject
);

export const savedSelector = createSelector(
    addProjectsFeatureSelector,
    (state: AddProject) => state.saved
);